// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2-Klt","error":"Textarea_error__oxlZx","readonly":"Textarea_readonly__3Qbn8","disabled":"Textarea_disabled__2dHg2"};